<template>
  <div class="industry-selector">
    <ue-select :options="industries" @input="selected" v-model="industry" />
  </div>
</template>
<script lang="ts">
import { mapState } from 'pinia'
import { useIndustryStore } from '@app/stores/IndustryStore'

export default {
  props: { value: { type: [Number, String], required: true } },
  emits: ['input'],
  data: () => ({
    industry: null,
  }),
  computed: {
    ...mapState(useIndustryStore, ['industries']),
  },
  beforeMount() {
    useIndustryStore()
      .fetchIndustries()
      .then(() => {
        this.industry = this.industries.filter((i) => parseInt(i.code) == parseInt(this.value))
      })
  },
  methods: {
    selected() {
      this.$emit('input', this.industry.code)
    },
  },
}
</script>
